module.exports = __webpack_public_path__ + "images/emoji/barber.84859902fa31480364bd.png";